"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const actionCreators = __importStar(require("./actions"));
const types_1 = require("../../../loading/types");
const initialState = {
    isLoading: types_1.LOADING_STATE.LOADING,
    data: [],
    current: null,
    fastenersExistence: [],
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.requestDefaultFastenersSuccess): {
            draft.isLoading = types_1.LOADING_STATE.COMPLETE;
            draft.data = action.payload;
            [draft.current] = action.payload;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestDefaultFastenersFail): {
            Object.assign(draft, initialState);
            draft.isLoading = types_1.LOADING_STATE.FAILED;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.setCurrentConnectionFasteners): {
            draft.current = action.payload;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.requestFastenersExistenceSuccess): {
            draft.fastenersExistence = action.payload;
            break;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.resetConnectionFasteners): {
            draft.current = null;
            draft.data = [];
            break;
        }
        default:
            break;
    }
});
exports.default = reducer;
